// extracted by mini-css-extract-plugin
module.exports = {"logo":"Start_logo__2iGvV","character":"Start_character__1NWEP","footer":"Start_footer__3BDMC"};